// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1upYW","right":"styles_right__1mvw_"};